import { useApi } from 'services';

export const useVerifyRiskAcceptance = (idOperation) => useApi(
    `/v2/operation/${idOperation}/risk-acceptance`,
    'POST',
    {},
    {}
);

export const useVerifyRiskAcceptanceAsync = (idOperation) => useApi(
    `/v2/operation/${idOperation}/risk-acceptance`,
    'POST',
    {},
    {},
    true
);